// Ponto de entrada único do design system "Viaja, Cris!" para o app.
// A ordem dos imports importa: React global → bundle → estilos.
import './react-global';
import '../vendor/bundle.js';
import './tokens.css';
import '../vendor/bundle.css';

export type {
  AlertCardProps,
  AlertMarkProps,
  ButtonProps,
  CalendarDay,
  ChanceMeterProps,
  ChipProps,
  EmptyStateProps,
  IconName,
  IconProps,
  LogoProps,
  MascotPose,
  MascotProps,
  Place,
  PriceCalendarProps,
  PriceChartProps,
  PriceLevelName,
  PriceLevelProps,
  PricePoint,
  PriceProps,
  PriceThermometerProps,
  PushNotificationProps,
  RouteCardProps,
  RouteSearchProps,
  SplashScreenProps,
  TelegramAlertProps,
} from '../vendor/index';

const DS = window.ViajaCris;
if (!DS) throw new Error('Design system ViajaCris não carregou (vendor/bundle.js).');

export const {
  AlertCard,
  AlertMark,
  Button,
  ChanceMeter,
  Chip,
  EmptyState,
  Icon,
  Logo,
  Mascot,
  Price,
  PriceCalendar,
  PriceChart,
  PriceLevel,
  PriceThermometer,
  PushNotification,
  RouteCard,
  RouteSearch,
  SplashScreen,
  TelegramAlert,
  formatBRL,
} = DS;
